// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  padding: 8px 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.view-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 8px;
}
.view-toolbar__count {
  font-family: var(--font);
  font-weight: 400;
  font-size: 13px;
  opacity: 0.7;
}
.view-toolbar__toggle {
  display: flex;
  gap: 2px;
}
.view-toolbar__toggle ion-button {
  --padding-start: 8px;
  --padding-end: 8px;
  width: 36px;
  height: 36px;
  opacity: 0.4;
  transition: opacity 0.2s ease;
}
.view-toolbar__toggle ion-button.active {
  opacity: 1;
}
.view-toolbar__toggle ion-button ion-icon {
  font-size: 20px;
}

.folder-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
  overflow-y: auto;
  flex: 1;
  padding: 4px 0 16px;
  align-content: start;
}

.folder-item ion-avatar {
  width: 78px;
  height: 98px;
  margin: 15px;
  display: flex;
  border: 1px solid;
  border-color: rgb(160, 160, 160);
}
.folder-item ion-avatar .default-img {
  width: 22px;
  height: 22px;
  margin: auto;
  border-radius: 0;
}
.folder-item ion-label {
  height: 48px;
  display: flex;
  align-items: center;
}
.folder-item ion-label h2 {
  font-family: var(--font);
  font-weight: 600;
}
.folder-item ion-label p {
  font-family: var(--font);
  font-weight: 300;
  font-size: 12px;
}

ion-avatar {
  --border-radius: 4px;
}

.style-item {
  cursor: pointer;
  --padding-start:10px;
  --inner-padding-bottom: 15px;
}

.style-item:hover {
  background-color: #dfdfdf;
  color: white;
}

@media (min-width: 1024px) {
  .folder-grid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 220px));
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/gallery/gallery.page.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;AACF;AACE;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AACJ;AAEE;EACE,aAAA;EACA,QAAA;AAAJ;AAEI;EACE,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;AAAN;AAEM;EACE,UAAA;AAAR;AAGM;EACE,eAAA;AADR;;AAOA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;EACA,OAAA;EACA,mBAAA;EACA,oBAAA;AAJF;;AAQI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gCAAA;AALR;AAMQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAJZ;AAOI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AALR;AAMQ;EACI,wBAAA;EAA0B,gBAAA;AAHtC;AAKQ;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAFZ;;AAMA;EACI,oBAAA;AAHJ;;AAKA;EACI,eAAA;EACA,oBAAA;EACA,4BAAA;AAFJ;;AAIA;EACI,yBAAA;EACA,YAAA;AADJ;;AAIA;EACE;IACE,8DAAA;EADF;AACF","sourcesContent":[".page-container {\n  padding: 8px 12px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.view-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 0 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  margin-bottom: 8px;\n\n  &__count {\n    font-family: var(--font);\n    font-weight: 400;\n    font-size: 13px;\n    opacity: 0.7;\n  }\n\n  &__toggle {\n    display: flex;\n    gap: 2px;\n\n    ion-button {\n      --padding-start: 8px;\n      --padding-end: 8px;\n      width: 36px;\n      height: 36px;\n      opacity: 0.4;\n      transition: opacity 0.2s ease;\n\n      &.active {\n        opacity: 1;\n      }\n\n      ion-icon {\n        font-size: 20px;\n      }\n    }\n  }\n}\n\n.folder-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 12px;\n  overflow-y: auto;\n  flex: 1;\n  padding: 4px 0 16px;\n  align-content: start;\n}\n\n.folder-item{\n    ion-avatar{\n        width: 78px;\n        height: 98px;\n        margin: 15px;\n        display: flex;\n        border: 1px solid;\n        border-color: rgb(160, 160, 160);\n        .default-img {\n            width: 22px;\n            height: 22px;\n            margin: auto;\n            border-radius: 0;\n        }\n    }\n    ion-label{\n        height: 48px;\n        display: flex;\n        align-items: center;\n        h2{\n            font-family: var(--font); font-weight: 600;;\n        }\n        p{\n            font-family: var(--font); font-weight: 300;;\n            font-size: 12px;\n        }\n    }\n}\nion-avatar{\n    --border-radius: 4px;\n}\n.style-item{\n    cursor: pointer;\n    --padding-start:10px;\n    --inner-padding-bottom: 15px;\n}\n.style-item:hover {\n    background-color: #dfdfdf;\n    color: white;\n}\n\n@media (min-width: 1024px) {\n  .folder-grid {\n    grid-template-columns: repeat(auto-fill, minmax(180px, 220px));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
